import { useEffect, useRef, useState } from "react";

export const useInViewAnimation = (enableInViewAnimation: boolean = false) => {
  const threshold = 0.1;
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setTimeout(() => {
            setIsVisible(true);
          }, 50);

          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold },
    );

    const currentRef = ref.current;
    if (currentRef && enableInViewAnimation) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, isVisible, enableInViewAnimation]);

  const animationClassName = "transition-all duration-500 ease-in-out";
  const visibilityClassName = isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0";

  if (!enableInViewAnimation) {
    return { ref, animationClassName: "", visibilityClassName: "" };
  }
  return { ref, animationClassName, visibilityClassName };
};
